// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Employees-Staff-ActionBar-__ActionBar___L9rt6","btn-invite-staff":"app-pages-Employees-Staff-ActionBar-__ActionBar___2ndmD"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/ActionBar/ActionBar.css
// module id = 2332
// module chunks = 0